import React from 'react';

import { Logger } from 'aws-amplify';

import { 
  ExecutionInputCard,
  useExecutionInput,
} from '../components/execution';

const logger = new Logger('ExecutionInput');

const ExecutionInput = ({ match }) => {
  const {
    params: { id, encodedInputUri },
  } = match;
  
  const inputUri = window.atob(encodedInputUri);

  const { executionInput, loading, error } = useExecutionInput(id, inputUri, {subscribed: true});

  if(error ) {
    logger.error(error);
    return(null);
  }
  
  if(!executionInput || loading ) {
    return(null); 
  }
  
  return (
    <ExecutionInputCard executionInput={executionInput}/>
  );
};

export default ExecutionInput;